import { useState } from "react";
import { api } from "@/lib/api";
import { safeLS } from "@/lib/safeStorage";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription,
} from "@/components/ui/dialog";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ChangePasswordModal() {
  const [open, setOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (next.length < 12) { toast.error("La nueva contraseña debe tener al menos 12 caracteres."); return; }
    if (next !== confirm) { toast.error("La confirmación no coincide."); return; }
    setSaving(true);
    try {
      const r = await api.post("/auth/change-password", { current_password: current, new_password: next });
      if (r.data?.token) safeLS.setItem("tm_token", r.data.token);
      toast.success("Contraseña actualizada. Las demás sesiones se cerraron.");
      setCurrent(""); setNext(""); setConfirm(""); setOpen(false);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo cambiar la contraseña.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button data-testid="change-password-button" variant="ghost" size="icon" className="text-slate-500 hover:text-emerald-700" title="Cambiar contraseña">
          <KeyRound className="h-5 w-5" />
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md" data-testid="change-password-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-emerald-950">
            <KeyRound className="h-5 w-5 text-emerald-700" /> Cambiar contraseña
          </DialogTitle>
          <DialogDescription>Ingrese su contraseña actual y la nueva contraseña.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="space-y-1.5">
            <Label>Contraseña actual</Label>
            <Input type="password" data-testid="current-password-input" value={current} onChange={(e) => setCurrent(e.target.value)} required />
          </div>
          <div className="space-y-1.5">
            <Label>Nueva contraseña</Label>
            <Input type="password" data-testid="new-password-input" value={next} onChange={(e) => setNext(e.target.value)} placeholder="Mínimo 6 caracteres" required />
          </div>
          <div className="space-y-1.5">
            <Label>Confirmar nueva contraseña</Label>
            <Input type="password" data-testid="confirm-password-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
          </div>
          <Button type="submit" data-testid="change-password-submit" disabled={saving} className="w-full bg-emerald-700 hover:bg-emerald-800">
            {saving ? <Loader2 className="h-4 w-4 mr-1.5 animate-spin" /> : <KeyRound className="h-4 w-4 mr-1.5" />}
            Actualizar contraseña
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
